export default __webpack_public_path__ + "static/media/n3.daedddb1.svg";